/**
 * Created by Ning Jiang on 2023-08-29.
 */
import {DevilsCrossRoadLayers, Layers} from "../view/DevilsCrossRoadLayers";
import {DCRoadSymbol} from "../symbol/DCRoadSymbol";
import {DevilsCrossRoadSymbolConfig} from "../symbol/DevilsCrossRoadSymbolConfig";
import {gsap, TimelineLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {DCRoadReelsController} from "./DCRoadReelsController";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class DCRoadReelsView {

    public static SYMBOL_WIDTH:number = 120;
    public static SYMBOL_HEIGHT:number = 120;
    public static REELS_CENTER:[number, number] = [360, 392];
    public static SYMBOL_POSITIONS:[number, number][][] = [
        [[-240, -240], [-240, -120], [-240, 0], [-240, 120], [-240, 240]],
        [[-120, -240], [-120, -120], [-120, 0], [-120, 120], [-120, 240]],
        [[0, -240], [0, -120], [0, 0], [0, 120], [0, 240]],
        [[120, -240], [120, -120], [120, 0], [120, 120], [120, 240]],
        [[240, -240], [240, -120], [240, 0], [240, 120], [240, 240]]
    ];
    // [number, number, number, number]: [reelId, symId, delayFromPreviousSymbol, fastSpinDelayFromPreviousSymbol].
    public static START_ORDER_WAVE_COUNTER:[number, number, number, number][] = [
        [1, 2, 0, 0], [2, 1, 0, 0], [3, 2, 0, 0], [2, 3, 0, 0], // inners
        [0, 3, 0.2, 0.1], [0, 2, 0, 0], [0, 1, 0, 0], //outer left
        [1, 0, 0, 0], [2, 0, 0, 0], [3, 0, 0, 0], // outer top
        [4, 1, 0, 0], [4, 2, 0, 0], [4, 3, 0, 0], // outer right
        [3, 4, 0, 0], [2, 4, 0, 0], [1, 4, 0, 0] //outer bottom
    ];

    public static NORMAL_STOP_DELAY:number = 0.05;
    public static NORMAL_STOP_WAVE_DELAY:number = 0.05;
    public static NORMAL_STOP_QUAD_DELAY:number = 0.15;
    public static QUICK_STOP_DELAY:number = 0.03;
    public static QUICK_STOP_WAVE_DELAY:number = 0.03;
    public static QUICK_STOP_QUAD_DELAY:number = 0.1;
    public static NEAR_WIN_STOP_DELAY:number = 1;
    public static SUPER_NEAR_WIN_STOP_DELAY:number = 2;

    // [number, number, number, number, number, number]: [reelId, symId, stoppedQuadId, waveId, delayFromPreviousSymbol, quickDelayFromPreviousSymbol, nearWinDelayId].
    // waveId: 0 = inner, 1 = outer
    // nearWinDelayId: 0 = no near win, 1 = outer normal near win, 2 = inner super near win
    public static STOP_ORDER_QUAD_COUNTER:[number, number, number, number, number, number, number][] = [
        [1, 2, -1, 0, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 2], [0, 3, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0], [0, 2, -1, 1, 0, 0, 1], [0, 1, 0, 1, 0, 0, 0], // left
        [2, 1, -1, 0, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 2], [1, 0, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0], [2, 0, -1, 1, 0, 0, 1], [3, 0, 3, 1, 0, 0, 0], // top
        [3, 2, -1, 0, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 2], [4, 1, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0], [4, 2, -1, 1, 0, 0, 1], [4, 3, 2, 1, 0, 0, 0], // right
        [2, 3, -1, 0, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 2], [3, 4, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0], [2, 4, -1, 1, 0, 0, 1], [1, 4, 1, 1, 0, 0, 0] // bottom
    ];
    public static STOP_ORDER_WAVE_COUNTER:[number, number, number, number, number, number, number][] = [
        [1, 2, -1, 0, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 2], [2, 1, -1, 0, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 2], [3, 2, -1, 0, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 2], [2, 3, -1, 0, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 2], // inners
        [0, 3, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0], [0, 2, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 1], [0, 1, 0, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0], //outer left
        [1, 0, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0], [2, 0, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 1], [3, 0, 3, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0], // outer top
        [4, 1, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0], [4, 2, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 1], [4, 3, 2, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0], // outer right
        [3, 4, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0], [2, 4, -1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 1], [1, 4, 1, 1, DCRoadReelsView.NORMAL_STOP_DELAY, DCRoadReelsView.QUICK_STOP_DELAY, 0] //outer bottom
    ];

    public stopQuadPadding:number = 0;

    private _avalancheSymbolStepDuration:number = 0.5;

    private _allSymbols:(DCRoadSymbol | null)[][] = [[], [], [], [], []];
    // private _spinAnimations:TimelineSprite[][] = [[], [], [], [], []];
    private _nearWinSpinSymbol:TimelineSprite;
    private _spinPositions:boolean[][];
    private _luckDrawNearWinCounter:number;
    private _nextStopSymbolCoords:[number, number, number][] = []; // reelId, symbolId, nearWinId
    public stopOrder:number[][];

    private readonly _spinContainer:PIXI.Container;
    private readonly _lowContainer:PIXI.Container;
    private readonly _highContainer:PIXI.Container;
    private readonly _lowWinContainer:PIXI.Container;
    private readonly _highWinContainer:PIXI.Container;
    private _allContainers:PIXI.Container[];

    constructor() {
        this._spinContainer = this.createSymbolContainer();
        DevilsCrossRoadLayers.getLayer(Layers.SPIN_SYMBOLS)?.addChild(this._spinContainer);
        this._lowContainer = this.createSymbolContainer();
        DevilsCrossRoadLayers.getLayer(Layers.LOW_SYMBOLS)?.addChild(this._lowContainer);
        this._highContainer = this.createSymbolContainer();
        DevilsCrossRoadLayers.getLayer(Layers.HIGH_SYMBOLS)?.addChild(this._highContainer);
        this._lowWinContainer = this.createSymbolContainer();
        DevilsCrossRoadLayers.getLayer(Layers.LOW_SYMBOLS_WIN)?.addChild(this._lowWinContainer);
        this._highWinContainer = this.createSymbolContainer();
        DevilsCrossRoadLayers.getLayer(Layers.HIGH_SYMBOLS_WIN)?.addChild(this._highWinContainer);
        this._allContainers = [this._lowContainer, this._highContainer, this._lowWinContainer, this._highWinContainer, this._spinContainer];

        this.resetSpinPositions();
    }

    private createSymbolContainer():PIXI.Container {
        const container = new PIXI.Container();
        container.position.set(DCRoadReelsView.REELS_CENTER[0], DCRoadReelsView.REELS_CENTER[1]);

        return container;
    }

    private resetSpinPositions():void {
        this._spinPositions = [
            [false, true, true, true, false],
            [true, false, true, false, true],
            [true, true, false, true, true],
            [true, false, true, false, true],
            [false, true, true, true, false]
        ];
    }

    public initSpinIndicators():void {
        this._nearWinSpinSymbol = new TimelineSprite(DevilsCrossRoad.assetLoader.getTextures("inwards_burst_fx/inwards_burst_"));
        this._nearWinSpinSymbol.anchor.set(0.5);
        this._nearWinSpinSymbol.blendMode = PIXI.BLEND_MODES.ADD;
        this._nearWinSpinSymbol.hide();
        this._spinContainer.addChild(this._nearWinSpinSymbol);
    }

    public addSymbol(symbol:DCRoadSymbol, init:boolean = false):TimelineLite {
        this.addSymbolToCoord(symbol);
        const landingTl = symbol.playLanding(init);
        DevilsCrossRoad.symbolLanding.addLanding(landingTl);
        if(DevilsCrossRoad.scatters.isLuckDrawNearWinPlaying) {
            if(symbol.symbolName !== "S") {
                DevilsCrossRoad.scatters.stopLuckDrawNearWin();
            } else {
                this._luckDrawNearWinCounter--;
                if(this._luckDrawNearWinCounter === 0) {
                    DevilsCrossRoad.scatters.stopLuckDrawNearWin();
                }
            }
            // TODO: this._luckDrawNearWinCounter
        }
        if(DevilsCrossRoadSymbolConfig.SYMBOLS[symbol.symbolName].highSymbol) {
            this._highContainer.addChild(symbol);
        } else {
            this._lowContainer.addChild(symbol);
        }
        return landingTl;
    }

    public addWinSymbol(symbol:DCRoadSymbol):void {
        this.addSymbolToCoord(symbol);
        if(DevilsCrossRoadSymbolConfig.SYMBOLS[symbol.symbolName].highSymbol) {
            this._highWinContainer.addChild(symbol);
            return;
        }
        this._lowWinContainer.addChild(symbol);
    }

    public removeSymbol(symbol:DCRoadSymbol):void {
        if(symbol.parent) {
            symbol.parent.removeChild(symbol);
        }
        this.removeSymbolFromCoord(symbol);
        symbol.onRemove();
    }

    public addSymbolToCoord(symbol:DCRoadSymbol, animate:boolean = false, playMoveSound:boolean = false):Promise<any> {
        if(this._allSymbols[symbol.reelId][symbol.symId] != symbol) {
            this._allSymbols[symbol.reelId][symbol.symId] = symbol;
            this._spinPositions[symbol.reelId][symbol.symId] = false;
            // Logger.logDev(`Added symbol ${symbol.symbolName} at [${symbol.reelId}, ${symbol.symId}]`);
        }
        const position = DCRoadReelsView.SYMBOL_POSITIONS[symbol.reelId][symbol.symId];
        if(animate) {
            const tl = gsap.timeline();
            tl.add(gsap.to(symbol, {
                duration : this._avalancheSymbolStepDuration,
                x : position[0],
                y : position[1]
            }));
            if(playMoveSound) {
                tl.add(() => {
                    DevilsCrossRoadSound.soundPlayer.playTrack({name : DevilsCrossRoadSound.SYMBOL_AVALANCHE});
                }, 0);
            }
            return Promise.resolve(tl);
        } else {
            symbol.position.set(position[0], position[1]);
            return Promise.resolve();
        }
    }

    public removeSymbolFromCoord(symbol:DCRoadSymbol):void {
        if(this._allSymbols[symbol.reelId][symbol.symId] === symbol) {
            this._allSymbols[symbol.reelId][symbol.symId] = null;
        }
    }

    public getSymbol(reelId:number, symId:number):DCRoadSymbol | null {
        return this._allSymbols[reelId][symId];
    }

    public startSpin(isAvalanche:boolean):TimelineLite {
        this._nextStopSymbolCoords = [];
        this.stopQuadPadding = 0;
        if(!isAvalanche) {
            this.resetSpinPositions();
        }
        const tl = gsap.timeline();
        let delay = 0;
        DCRoadReelsView.START_ORDER_WAVE_COUNTER.forEach(coord => {
            if(this._spinPositions[coord[0]][coord[1]]) {
                delay += SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN) ? coord[3] : coord[2];
                const oldSymbol = this._allSymbols[coord[0]][coord[1]];
                const symTl = gsap.timeline();
                if(oldSymbol) {
                    symTl.add(oldSymbol.playSpinRemove());
                }
                Logger.logDev(`start spin on position [${coord[0]}][${coord[1]}] at delay ${delay}`);
                symTl.add(() => {
                    if(oldSymbol) {
                        this.removeSymbol(oldSymbol);
                    }
                });
                tl.add(symTl, delay);
            }
        });

        tl.add(() => {
            // Logger.logDev(`------------------------start spin completed at total duration ${tl.totalDuration()}`);
        }, Math.max(0.5, delay));
        return tl;
    }

    public stopSpin(reels:string[][], isQuickStop:boolean, addSymbolCallback:(symName:string, reelId:number, symId:number, init:boolean) => DCRoadSymbol, quadCompleteCallback:(quadId:number) => void):TimelineLite {
        this._luckDrawNearWinCounter = 4;
        let newQuad = false;
        let newWave:boolean;
        let waveId = -1;
        const tl = gsap.timeline();
        tl.add(() => {
            // Logger.logDev(`------------reel is stopping.`);
        });
        let delay = 0;
        let previousStopOrderId = -1;
        this.stopOrder.forEach((coord, stopOrderId) => {
            if(this._spinPositions[coord[0]][coord[1]]) {
                if(previousStopOrderId > -1) {
                    this._nextStopSymbolCoords[previousStopOrderId] = [coord[0], coord[1], coord[6]];
                } else {
                    // first symbol
                    this.tryPlaySymbolPositionNearWin([coord[0], coord[1], coord[6]]);
                }
                previousStopOrderId = stopOrderId;
                newWave = newQuad ? false : (coord[3] - waveId > 0);
                delay += this.getSymbolStopDelay(coord, isQuickStop, newQuad, newWave);
                Logger.logDev(`will stop spin on position [${coord[0]}][${coord[1]}] at delay ${delay}`);
                tl.add(() => {
                    this._nearWinSpinSymbol.stopLoop();
                    this._nearWinSpinSymbol.visible = false;
                    addSymbolCallback(reels[coord[0]][coord[1]], coord[0], coord[1], false);
                    Logger.logDev(`spin stopped on position [${coord[0]}][${coord[1]}]`);
                    this.tryPlayNextSymbolPositionNearWin(stopOrderId);
                }, delay);
                newQuad = false;
                waveId = coord[3];
            }
            if(coord[2] > -1) {
                tl.add(() => {
                    quadCompleteCallback(coord[2]);
                }, delay);
                newQuad = true;
            }
        });

        tl.add(() => {
            // Logger.logDev(`--------------------stop spin completed at total duration ${tl.totalDuration()}`);
        });
        return tl;
    }

    private getSymbolStopDelay(coord:number[], isQuickStop:boolean, newQuad:boolean, newWave:boolean):number {
        if(coord[6] > 0) {
            const nearWinState = DevilsCrossRoad.scatters.getPositionNearWinState(coord[0], coord[1]);
            switch(nearWinState) {
                case 2:
                    return DCRoadReelsView.SUPER_NEAR_WIN_STOP_DELAY;
                case 1:
                    return DCRoadReelsView.NEAR_WIN_STOP_DELAY;
                default:
                // find other delay.
            }
        }
        if(SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN) || isQuickStop) {
            if(newQuad) {
                return coord[5] + DCRoadReelsView.QUICK_STOP_QUAD_DELAY;
            }
            if(newWave) {
                return coord[5] + DCRoadReelsView.QUICK_STOP_WAVE_DELAY;
            }
            return coord[5];
        }

        if(newQuad) {
            return coord[4] + DCRoadReelsView.NORMAL_STOP_QUAD_DELAY + this.stopQuadPadding;
        }
        if(newWave) {
            return coord[4] + DCRoadReelsView.NORMAL_STOP_WAVE_DELAY;
        }

        return coord[4];
    }

    // reelId, symbolId, nearWinId
    private tryPlaySymbolPositionNearWin(coord:[number, number, number]):void {
        if(coord[2] === 0) {
            return;
        }
        const nearWinState = DevilsCrossRoad.scatters.getPositionNearWinState(coord[0], coord[1]);
        Logger.logDev(`next stop spin on position [${coord[0]}][${coord[1]}] near win state is ${nearWinState}`);
        if(nearWinState > 0) {
            const position = DCRoadReelsView.SYMBOL_POSITIONS[coord[0]][coord[1]];
            this._nearWinSpinSymbol.position.set(position[0], position[1]);
            this._nearWinSpinSymbol.playLoop();
            this._nearWinSpinSymbol.show();
        }
    }

    private tryPlayNextSymbolPositionNearWin(stopOrderId:number):void {
        const nextSymbolCoord = this._nextStopSymbolCoords[stopOrderId];
        Logger.logDev(`next stop spin on position ${nextSymbolCoord}`);
        if(nextSymbolCoord) {
            this.tryPlaySymbolPositionNearWin(nextSymbolCoord);
        }
    }

    public removeAllWinSymbols():TimelineLite {
        const tl = gsap.timeline();

        this._allSymbols.forEach(reel => {
            reel.forEach(sym => {
                if(sym?.isWin || sym?.isMulti) {
                    const removeSymTl = gsap.timeline();
                    removeSymTl.add(sym.playWinRemove());
                    removeSymTl.add(() => {
                        this._spinPositions[sym.reelId][sym.symId] = true;
                        this.removeSymbol(sym);
                    });
                    tl.add(removeSymTl, 0);
                }
            });
        });

        return tl;
    }

    public avalanche():Promise<any> {
        let hasAvalanche = false;
        const promises:Promise<any>[] = [];
        DCRoadReelsController.AVALANCHE_PATHS.forEach(path => {
            const innerP = path[0];
            const outerP = path[1];
            if(this._spinPositions[innerP[0]][innerP[1]] && !this._spinPositions[outerP[0]][outerP[1]]) {
                this._spinPositions[outerP[0]][outerP[1]] = true;
                const sym = this._allSymbols[outerP[0]][outerP[1]]!;
                this.removeSymbolFromCoord(sym);
                sym.reelId = innerP[0];
                sym.symId = innerP[1];
                promises.push(this.addSymbolToCoord(sym, true, !hasAvalanche));
                if(sym.playAvalanche) {
                    promises.push(Promise.resolve(sym.playAvalanche()));
                }
                hasAvalanche = true;
            }
        });

        return Promise.all(promises);
    }

    public startNearWin():void {
        this._allSymbols.forEach((reel, reelId) => {
            reel.forEach((sym, symId) => {
                if(sym) {
                    sym.shakeNearWin();
                }
            });
        });
    }

    public stopNearWin():void {
        this._allSymbols.forEach((reel, reelId) => {
            reel.forEach((sym, symId) => {
                if(sym) {
                    sym.stopNearWin();
                }
            });
        });
    }

    public show(value:boolean):void {
        this._allContainers.forEach(container => {
            container.visible = value;
        });
        DevilsCrossRoad.devil.show(value);
        DevilsCrossRoad.multipliers.show(value);
    }

    public hasDevWayScatterPositionSpin(devWay:number):boolean {
        if(DCRoadReelsController.AVALANCHE_PATHS[devWay]) {
            return DCRoadReelsController.AVALANCHE_PATHS[devWay].some((position => {
                return this._spinPositions[position[0]][position[1]];
            }));
        }
        return false;
    }
}